import React, { useEffect, useState, useContext } from "react";
import moment from "moment";
import { InputLabel } from "@mui/material";
import { Card, CardBody, Col, Row } from "reactstrap";

import CustomDatePicker from "views/pages/manage/common/commonComponents/CustomDatePicker";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import { isFilterApplied } from "views/pages/manage/edpOps/constant/batch-search";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";

import { InputLabelStyle } from "../manage-receipts/constants";
import { FILTER_MENU, EPMRContext } from "./context";
import { getDropdowns, statusDropdown } from "./constants";

const EpmrFilterMenu = ({ businessAreaOptions, closeForm, applyFilters }) => {
  const {
    globalFilter,
    dropdownOptions,
    setDropdownOptions,
    filterCount,
    setFilterCount,
  } = useContext(EPMRContext);

  const [filterForm, setFilterForm] = useState(prefillFormFields());

  function prefillFormFields() {
    return {
      employeeId: globalFilter.employeeId,
      courseId: globalFilter.courseId,
      epmrNumber: globalFilter.epmrNumber,
      paymentMode: globalFilter.paymentMode,
      businessAreaId: globalFilter.businessAreaId,
      status: globalFilter.status,
      receiptDateFrom: globalFilter.receiptDateFrom,
      receiptDateTo: globalFilter.receiptDateTo,
    };
  }

  const {
    employeeId,
    courseId,
    epmrNumber,
    paymentMode,
    businessAreaId,
    status,
    receiptDateFrom,
    receiptDateTo,
  } = filterForm; // destructuring

  useEffect(() => {
    const fetchDropdown = async () => {
      const response = await getDropdowns();
      setDropdownOptions(response);
    };

    if (!dropdownOptions.paymode.length) {
      // call API
      fetchDropdown();
    }
  }, []);

  const filterFormHandler = (key, value) => {
    setFilterForm((prev) => ({ ...prev, [key]: value ?? [] }));
  };

  const resetFilterForm = () => {
    closeForm();
    setFilterForm(FILTER_MENU);
    applyFilters(FILTER_MENU);

    setFilterCount(0);
  };

  const handleApplyFilter = () => {
    closeForm();

    const filterCount = isFilterApplied({
      ...filterForm,
    });
    setFilterCount(filterCount);

    applyFilters(filterForm);
  };

  return (
    <Card
      className="mb-0 regular-body label-color"
      style={{ width: "330px", borderRadius: "12px" }}
    >
      <CardBody className="d-flex flex-column">
        <div className="text-bold text-lg mb-2">Filters</div>

        <div className="d-flex flex-column gap-md">
          <AInput
            label="EPMR No."
            type="text"
            value={epmrNumber}
            handler={(value) => {
              filterFormHandler("epmrNumber", value);
            }}
            onKeyDown={(e) => {
              const { value } = e.target;
              if (e.key === "Backspace" && value.length === 1)
                filterFormHandler("epmrNumber", "");
            }}
            placeholder="Enter"
            labelStyle={{ marginBottom: 0 }}
            regex={new RegExp("^[A-Za-z0-9]+$")}
            maxLength={12}
          />

          <AAutoComplete
            // height={inputHeight}
            label="Business Area"
            placeholder="Select"
            items={businessAreaOptions.map((bu) => ({
              label: bu.label,
              value: bu.businessAreaId,
            }))}
            currentValue={businessAreaId}
            isShowCount={true}
            handleChange={(value) => {
              filterFormHandler("businessAreaId", value);
            }}
            inputKey="businessAreaId"
          />

          <AInput
            type="text"
            label="Employee Id"
            value={employeeId}
            handler={(value) => {
              filterFormHandler("employeeId", [value]);
            }}
            labelStyle={{ marginBottom: 0 }}
            placeholder="Enter"
          />

          <AInput
            type="text"
            label="Course Id"
            value={courseId}
            handler={(value) => {
              filterFormHandler("courseId", [value]);
            }}
            onKeyDown={(e) => {
              const { value } = e.target;
              if (e.key === "Backspace" && value.length === 1)
                filterFormHandler("courseId", "");
            }}
            labelStyle={{ marginBottom: 0 }}
            placeholder="Enter"
            regex={new RegExp("^[0-9]+$")}
            maxLength={6}
          />

          <AAutoComplete
            label="Payment Mode"
            placeholder="Select"
            items={dropdownOptions?.paymode}
            currentValue={paymentMode}
            isShowCount={true}
            handleChange={(value) => {
              filterFormHandler("paymentMode", value);
            }}
            inputKey=""
          />

          <AAutoComplete
            label="Status"
            placeholder="Select"
            items={statusDropdown}
            currentValue={status}
            isShowCount={true}
            handleChange={(value) => {
              filterFormHandler("status", value);
            }}
            inputKey=""
          />

          <div>
            <InputLabel style={InputLabelStyle}>EPMR Date</InputLabel>
            <Row>
              <Col sm="6">
                <CustomDatePicker
                  placeHolder="From"
                  // minDate={moment()}
                  value={receiptDateFrom ? moment(receiptDateFrom) : null}
                  handler={(index, date, keyName) => {
                    filterFormHandler("receiptDateFrom", date);
                    filterFormHandler("receiptDateTo", "");
                  }}
                  maxDate={moment()}
                />
              </Col>
              <Col sm="6">
                <CustomDatePicker
                  placeHolder="To"
                  value={receiptDateTo ? moment(receiptDateTo) : null}
                  handler={(index, date, keyName) => {
                    filterFormHandler("receiptDateTo", date);
                  }}
                  minDate={moment(receiptDateFrom)}
                  maxDate={moment()}
                  disabled={!receiptDateFrom}
                />
              </Col>
            </Row>
          </div>

          <div className="mt-3 d-flex flex-row-reverse justify-content-between">
            <AButton
              variant="primary_filled"
              className="w-full"
              onClick={handleApplyFilter}
              disabled={
                isFilterApplied({
                  ...filterForm,
                }) == 0
              }
            >
              Apply filter
            </AButton>

            {filterCount > 0 && (
              <AButton
                variant="outline"
                className="button_remove_left_margin"
                updatedStyle={{ border: "1px solid #CC5F5F", color: "#CC5F5F" }}
                onClick={resetFilterForm}
              >
                Remove filter
              </AButton>
            )}
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default EpmrFilterMenu;
